import { bootstrapApplication } from '@angular/platform-browser';
import { provideClientHydration, withNoHttpTransferCache } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    ...appConfig.providers,
    provideClientHydration(withNoHttpTransferCache())
  ]
}).catch((err) => console.error(err));
